import { render, staticRenderFns } from "./tutorials.vue?vue&type=template&id=4d2ec2f7"
import script from "./tutorials.vue?vue&type=script&lang=js"
export * from "./tutorials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports